<template>
    <div class="project" @click="onClick">
        <Picture class="thumbnail" :src="project.thumbnail.layouts.transformed.lowQualityUrl" size="contain" :ratio="16/9"/>
        <h4 v-line-clamp="1">
            {{ project.title }}
        </h4>
        <p v-line-clamp="1">
            {{ project.description }}
        </p>
        <p v-line-clamp="1">
            <i>{{ date }}</i>
        </p>
        <div class="actions">
            <ul>
                <li>
                    <a @click.stop="onShareFacebook">
                        <IconFacebook :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
                <li>
                    <a @click.stop="onShareTwitter">
                        <IconTwitter :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
                <li v-if="project.lastOutput">
                    <a
                        :href="project.lastOutput.url"
                        :download="project.lastOutput.filename"
                        target="_blank"
                        @click="(e) => e.stopPropagation()"
                    >
                        <IconDownload :color="config.COLOR_PRIMARY"/>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { SocialConsumer, SolutionConsumer, ProjectConsumer } from '../../mixins';

export default {
    name: 'ProjectCard',
    mixins: [SocialConsumer, SolutionConsumer, ProjectConsumer],
    props: {
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        date () {
            return new Date(this.project.createdAt * 1000).toLocaleDateString();
        },
    },
    methods: {
        onClick () {
            this.$emit('click', this.project);
        },
        onShareFacebook () {
            this.shareFacebook(this.getPlayerFrontURL(this.project.id));
        },
        onShareTwitter () {
            this.shareTwitter(this.getPlayerFrontURL(this.project.id));
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';
@import '../../assets/scss/mixins';

.project {
    @include card(10px);
    @include card-hover();
    display: grid;
    column-gap: 10px;
    align-items: center;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: repeat(4, auto);
    cursor: pointer;
    transition: all .2s ease-in-out;

    > .thumbnail {
        grid-row: span 4;
    }

    > h4 {
        margin: 0;
    }

    > .actions {
        justify-self: flex-end;

        > ul {
            @include ul-horizontal(16px);

            > li {
                &:hover {
                    filter: brightness(1.1);
                }

                > a {
                    @include a-reset();
                    cursor: pointer;

                    > svg {
                        @include square(16px);
                    }
                }
            }
        }
    }
}
</style>
